import { forwardRef } from "react";

const DateInput = forwardRef(
  ({ calendarIcon, placeholderText, onClick, ...props }, ref) => {
    return (
      <div className="custom-date-input" onClick={onClick}>
        <input
          id="dateInput"
          type="text"
          ref={ref}
          placeholder={placeholderText}
          {...props}
        />
        <label htmlFor="dateInput">{calendarIcon}</label>
      </div>
    );
  }
);

export default DateInput;
